import React, { memo, useState } from "react";
import styled from "styled-components/native";
import RadioButton from "@components/atoms/RadioButton";
import { Button, Container } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import { ButtonCategory, ButtonType } from "@components/atoms/Button/types";
import { useTheme } from "styled-components/native";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { useTranslation } from "react-i18next";
import { HoursSlideSheetProps } from "../types";
import { css } from "styled-components/native";
import { DefaultTheme } from "styled-components/native";

const HoursSlideSheet = ({
  onApply,
  itemDetail,
  closeModal,
  selectedHours: propSelectedHours,
}: HoursSlideSheetProps) => {
  const userInfo = useUserInfo();
  const { t } = useTranslation();
  const Hours = userInfo.user.feature_settings.max_hold_hours;
  const firstHoursNumber = Number(Hours[0]);
  const firstLabel =
    firstHoursNumber > 72
      ? `${firstHoursNumber / 24} ${t("bmh.hold.hour.type.days.text")}`
      : `${firstHoursNumber} ${t("bmh.hold.hour.type.hour.text")}`;
  const [selectedHours, setSelectedHours] = useState(
    propSelectedHours || firstLabel
  );
  const theme = useTheme();
  const handleEvent = () => {
    if (selectedHours) {
      onApply(selectedHours);
      closeModal();
    }
  };

  return (
    <>
      <OverLay>
        <RadioButtonContainer>
          {Hours.map((hours, index) => {
            const hoursNumber = Number(hours);
            const label =
              hoursNumber > 72
                ? `${hoursNumber / 24} ${t("bmh.hold.hour.type.days.text")}`
                : `${hoursNumber} ${t("bmh.hold.hour.type.hour.text")}`;
            return (
              <React.Fragment key={index}>
                <Container>
                  <RadioContainer>
                    <RadioButton
                      label={label}
                      checked={selectedHours === label}
                      labelColor={
                        selectedHours === hours
                          ? theme["core-05"]
                          : theme["core-06"]
                      }
                      onPress={() => setSelectedHours(label)}
                    />
                  </RadioContainer>
                </Container>
              </React.Fragment>
            );
          })}
        </RadioButtonContainer>
        <ButtonContainer>
          <ContainerOverlay>
            <Button
              type={ButtonType.primary}
              category={
                itemDetail?.type === "diamond"
                  ? ButtonCategory.diam
                  : itemDetail?.type === "gemstone"
                  ? ButtonCategory.gem
                  : itemDetail?.type === "jewelry"
                  ? ButtonCategory.jewelry
                  : ButtonCategory.lab
              }
              title={"Done"}
              onPress={handleEvent}
            />
          </ContainerOverlay>
        </ButtonContainer>
      </OverLay>
    </>
  );
};

const OverLay = styled.View`
  min-height: 610px;
  justify-content: space-between;
`;

const RadioButtonContainer = styled.View`
  background-color: ${({ theme }: { theme: DefaultTheme }) =>
    theme["core-01"] as string};
`;

const RadioContainer = styled.View`
  padding-top: ${SpaceType.ExtraSmall}px;
  padding-bottom: ${SpaceType.ExtraSmall}px;
`;

const ButtonContainer = styled.View`
  padding-top: ${SpaceType.Big}px;
  padding-bottom: ${SpaceType.ExtraLarge}px;
  padding-horizontal: ${SpaceType.Double}px;
  align-items: center;
  ${({ theme }: { theme: DefaultTheme }) =>
    !theme.isMobile &&
    css`
      padding-horizontal: 0px;
    `}
`;

const ContainerOverlay = styled.View`
  width: 100%;
  ${({ theme }: { theme: DefaultTheme }) =>
    !theme.isMobile &&
    css`
      max-width: 343px;
    `}
`;

export default memo(HoursSlideSheet);
